import Button from 'src/components/primitives/Button/Button';
import useCompleteSurveyLater from 'src/components/UserSurvey/hooks/useCompleteSurveyLater';
import { UserSurveyContentProps } from 'src/components/UserSurvey/types';

type Props = Omit<UserSurveyContentProps, 'currentPage' | 'closeSurvey'>;

const DEFAULT_INTRO_TEXT =
	"Hey, we noticed you're an active trader, and we really value that. We'd love to hear your thoughts on how Drift is working for you.";

export default function UserSurveyIntroPage({ survey, setCurrentPage }: Props) {
	const [, setCompleteSurveyLater] = useCompleteSurveyLater();

	// There's a bug in the PostHog API causing `description` to not be returned.
	// So until that's fixed we're using `thankYouMessageCloseButtonText` as the
	// text vehicle since we don't use it for anything else.
	const introText =
		survey.description ||
		survey.appearance?.thankYouMessageCloseButtonText ||
		DEFAULT_INTRO_TEXT;

	return (
		<>
			<span className="typo-b4 text-text-default">{introText}</span>

			<div className="grid grid-cols-2 gap-x-md">
				<Button
					size="md"
					variant="secondary"
					onClick={() => setCompleteSurveyLater(true)}
				>
					Later
				</Button>
				<Button size="md" onClick={() => setCurrentPage(1)}>
					Start Survey
				</Button>
			</div>
		</>
	);
}
